import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { PopularPlaceCreateRequestBody, PopularPlaceCreateResponse } from "./types";

export class PopularPlaceCreateAPI extends BaseAPI<
    PopularPlaceCreateRequestBody,
    PopularPlaceCreateResponse
> {
    protected route = ApiRoutes.popular_place.create;
    protected method = RequestMethod.POST;
}
